import React, { useEffect } from "react";
import "../styles/checkout.css";
import CheckoutDetailsCard from "../components/CheckoutDetailsCard";
import ShippingAddressCard from "../components/ShippingAddressCard";

import OrderSummaryCard from "../components/OrderSummaryCard";
import { useNavigate, useLocation } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useState } from "react";
import { useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import { trackEvent } from "../utils/analytics";


const stripePromise = loadStripe("pk_live_51TblU4L0sA58YoXrYJGrrAlSkBJCgA3p63X3dXAjOEPeSeUkPwPYI1YF11NLSukbHzTzFyuFnUZLRzpaJRlt08MV00TH4KUDPG");




function PaymentForm({
  clientSecret,
  onSuccess,
  setPayNowHandler,
  checkoutData,
  userId,
  savedCard,
  product,
  quantity,
  selectedCondition,
  selectedVariant,
  price,
  appliedCredit = 0
}){



  
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

const checkoutDataRef = React.useRef(checkoutData);
useEffect(() => {
  checkoutDataRef.current = checkoutData;
}, [checkoutData]);

const savedCardRef = React.useRef(savedCard);
useEffect(() => {
  savedCardRef.current = savedCard;
}, [savedCard]);


const handleSubmit = useCallback(async () => {
const checkoutData = checkoutDataRef.current;
const savedCard = savedCardRef.current;


    if (!stripe || !elements || loading) return;

setLoading(true);
    setErrorMsg("");

    // Sync payment intent with current cart total right before charging
    try {
      const piId = clientSecret.split("_secret_")[0];
      await fetch("https://eleven11-i6v4.onrender.com/api/payments/update-payment-intent", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ paymentIntentId: piId, appliedCredit: appliedCredit })
      });
    } catch (err) {
      console.error("Failed to sync payment intent:", err);
    }

    const cardElement = elements.getElement(CardElement);

  const { error, paymentIntent } = await stripe.confirmCardPayment(
  clientSecret,
  savedCard
    ? { payment_method: savedCard.id }
    : {
        payment_method: {
          card: cardElement,
          billing_details: {
            name: `${checkoutData.firstName} ${checkoutData.lastName}`,
            email: checkoutData.email
          }
        }
      }
);

    setLoading(false);

  if (error) {
  setErrorMsg(error.message);

} else if (paymentIntent) {






if (
  paymentIntent.status === "succeeded" ||
  paymentIntent.status === "processing" ||
  paymentIntent.status === "requires_capture"
) {

const cartRes = await fetch("https://eleven11-i6v4.onrender.com/api/cart");
const cartData = await cartRes.json();
const cartItems = Array.isArray(cartData.items) && cartData.items.length > 0
  ? cartData.items.map(item => ({
      listingId: item.listingId,
      title: item.title,
      image: item.image || "",
      partNumber: item.partNumber || "",
      selectedCondition: item.selectedCondition || "",
      selectedVariant: item.selectedVariant || "",
      price: Number(item.price),
      qty: Number(item.qty || 1)
    }))
  : [{
      listingId: product?.listingId || product?._id,
      title: product?.title,
      image: product?.image || product?.images?.[0] || "",
      partNumber: product?.partNumber || "",
      selectedCondition,
      selectedVariant,
      price: Number(price),
      qty: Number(quantity || 1)
    }];





  const orderRes = await fetch("https://eleven11-i6v4.onrender.com/api/orders", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },


body: JSON.stringify({
  paymentIntentId: paymentIntent.id,
  userId: userId,
  appliedCredit: appliedCredit,
  customer: {


    firstName: checkoutData.firstName,
    lastName: checkoutData.lastName,
    email: checkoutData.email,
    phone: checkoutData.phone
  },

  shippingAddress: {
    address: checkoutData.address,
    apartment: checkoutData.apartment,
    city: checkoutData.city,
    state: checkoutData.state,
    zip: checkoutData.zip,
    country: checkoutData.country
  },

  items: cartItems

})
  });

  let orderData = {};



  try {
    orderData = await orderRes.json();
  } catch (e) {
    console.error("Invalid JSON response");
  }
  


  if (!orderRes.ok) {
    setErrorMsg(orderData.error || "Order creation failed");
    return;
  }

  await fetch("https://eleven11-i6v4.onrender.com/api/cart/clear", {
    method: "DELETE"
  });


const token = localStorage.getItem("token");
if (token) {
  await fetch("https://eleven11-i6v4.onrender.com/auth/me/address", {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  body: JSON.stringify({
      phone: checkoutData.phone,
      address: checkoutData.address,
      apartment: checkoutData.apartment,
      city: checkoutData.city,
      state: checkoutData.state,
      zip: checkoutData.zip,
      country: checkoutData.country
    })
  });
}

const orderId = orderData.orderId;

if (!orderId) {
  setErrorMsg("Order ID missing");
  return;
}

onSuccess(orderId);




}



else {
    setErrorMsg("Payment not completed. Status: " + paymentIntent.status);
  }
}
},  [
  stripe,
  elements,
  loading,
  clientSecret,
  checkoutData,
  userId,
  savedCard,
  product,
  quantity,
  selectedCondition,
  selectedVariant,
  price,
  appliedCredit
]);

useEffect(() => {
    if (setPayNowHandler) {
      setPayNowHandler(() => handleSubmit);
    }
  }, [handleSubmit]);



return (
  <div>
    {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}
  </div>
);
}

export default function Checkout() {
const navigate = useNavigate();

const location = useLocation();

const {
  product,
  quantity,
  selectedCondition,
  selectedVariant,
  price
} = location.state || {};

const { user, loading } = useAuth();
const [clientSecret, setClientSecret] = useState("");
const [checkoutMode, setCheckoutMode] = useState(null);

const [payNowHandler, setPayNowHandler] = useState(null);
const [savedCard, setSavedCard] = useState(null);
const [appliedCredit, setAppliedCredit] = useState(0);
const [paymentIntentId, setPaymentIntentId] = useState("");
const [checkoutData, setCheckoutData] = useState({
  firstName: user?.firstName || "",
  lastName: user?.lastName || "",
  email: user?.email || "",
  phone: user?.phone || "",
  address: user?.shippingAddress?.address || "",
  apartment: user?.shippingAddress?.apartment || "",
  city: user?.shippingAddress?.city || "",
  state: user?.shippingAddress?.state || "",
  zip: user?.shippingAddress?.zip || "",
  country: user?.shippingAddress?.country || "United States"
});

const [shippingValid, setShippingValid] = useState(
  !!(user?.firstName && user?.lastName && user?.email && user?.phone && user?.shippingAddress?.address && user?.shippingAddress?.city && user?.shippingAddress?.state && user?.shippingAddress?.zip)
);
const shippingValidateRef = React.useRef(null);
 

useEffect(() => {
  trackEvent("checkout_started");
}, []);

useEffect(() => {
  fetch("https://eleven11-i6v4.onrender.com/api/cart")
    .then(r => r.json())
    .then(cartData => {
      const items = Array.isArray(cartData.items) ? cartData.items : [];
      const cartTotal = items.reduce(
        (sum, item) => sum + Number(item.price || 0) * Number(item.qty || 1), 0
      );
      const finalPrice = cartTotal > 0 ? cartTotal : Number(price);

  const token = localStorage.getItem("token");
return fetch("https://eleven11-i6v4.onrender.com/api/payments/create-payment-intent", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  },


        body: JSON.stringify({
          productId: product?.listingId,
          quantity,
          selectedCondition,
          selectedVariant,
          price: finalPrice
        }),
      });
    })
    .then(res => res.json())
    .then(data => {
if (data.clientSecret) {
  setClientSecret(data.clientSecret);
  setPaymentIntentId(data.clientSecret.split("_secret_")[0]);
  if (data.savedCard) setSavedCard(data.savedCard);
}else {


     console.error("Payment setup failed:", data.error);
      }
    })
    .catch(err => console.error("Payment intent error:", err));
}, []);


const handleApplyCredit = async (amount) => {
  setAppliedCredit(amount);
  if (!paymentIntentId) return;
  try {
    await fetch("https://eleven11-i6v4.onrender.com/api/payments/update-payment-intent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ paymentIntentId, appliedCredit: amount })
    });
  } catch (err) {
    console.error("Failed to update payment intent:", err);
  }
};

useEffect(() => {
  if (!loading && user && !checkoutMode) {
    setCheckoutMode("account");
  }
}, [user, loading]);


const userSynced = React.useRef(false);
useEffect(() => {
  if (user && !userSynced.current) {
    userSynced.current = true;
    setCheckoutData(prev => ({
      ...prev,
      firstName: prev.firstName || user.firstName || "",
      lastName: prev.lastName || user.lastName || "",
      email: prev.email || user.email || "",
      phone: prev.phone || user.phone || "",
      address: prev.address || user.shippingAddress?.address || "",
      apartment: prev.apartment || user.shippingAddress?.apartment || "",
      city: prev.city || user.shippingAddress?.city || "",
      state: prev.state || user.shippingAddress?.state || "",
      zip: prev.zip || user.shippingAddress?.zip || "",
      country: prev.country || user.shippingAddress?.country || "United States",
    }));
  }
}, [user]);


useEffect(() => {
  const header = document.querySelector(".header-wrapper");

  if (header) {
    const headerHeight = header.offsetHeight;

    window.scrollTo({
      top: headerHeight + 20,
      behavior: "auto"
    });
  }
}, []);



if (loading) {
  return (
    <div style={{ minHeight: "100vh", background: "#F6F7FB", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ fontSize: 15, color: "#9CA3AF", fontWeight: 600 }}>Loading...</div>
    </div>
  );
}

if (!checkoutMode) {
  return (
    <div style={{ minHeight: "100vh", background: "#F6F7FB", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "-apple-system, BlinkMacSystemFont, system-ui" }}>
      <div style={{ width: "100%", maxWidth: 520, background: "#fff", borderRadius: 28, padding: "48px 40px", boxShadow: "0 8px 40px rgba(0,0,0,0.08)" }}>
        
        <h2 style={{ fontSize: 26, fontWeight: 700, letterSpacing: -0.5, margin: "0 0 8px" }}>How would you like to checkout?</h2>
        
        <p style={{ fontSize: 14, color: "#6B7280", margin: "0 0 32px", lineHeight: "20px" }}>
          We recommend creating an account so you can track your order, save your PWC details, and get faster checkout next time.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

          <button
            onClick={() => navigate("/auth")}
            style={{ width: "100%", padding: "16px", borderRadius: 16, border: "2px solid #0f0f17", background: "#0f0f17", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer" }}
          >
            Login to My Account
          </button>

          <button
            onClick={() => navigate("/auth")}
            style={{ width: "100%", padding: "16px", borderRadius: 16, border: "2px solid #E5E7EB", background: "#fff", color: "#0f0f17", fontSize: 15, fontWeight: 700, cursor: "pointer" }}
          >
            Create Account
            <span style={{ display: "block", fontSize: 12, fontWeight: 500, color: "#6B7280", marginTop: 2 }}>Recommended — track orders & faster checkout</span>
          </button>

          <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "4px 0" }}>
            <div style={{ flex: 1, height: 1, background: "#E5E7EB" }} />
            <span style={{ fontSize: 13, color: "#9CA3AF" }}>or</span>
            <div style={{ flex: 1, height: 1, background: "#E5E7EB" }} />
          </div>

          <button
            onClick={() => setCheckoutMode("guest")}
            style={{ width: "100%", padding: "16px", borderRadius: 16, border: "1px solid #E5E7EB", background: "#F9FAFB", color: "#6B7280", fontSize: 15, fontWeight: 600, cursor: "pointer" }}
          >
            Continue as Guest
         <span style={{ display: "block", fontSize: 12, fontWeight: 500, color: "#9CA3AF", marginTop: 2 }}>You can still track your order as long as you use your email</span>
          </button>

        </div>
      </div>
    </div>
  );
}

return (
  <div className="checkout-page">

      {/* Header */}
     
     

      {/* Main Container */}
      <div className="checkout-container">

        {/* Breadcrumb */}
        <div className="checkout-breadcrumb">
          <span>Shopping Cart</span>
          <span className="breadcrumb-divider">›</span>
          <span className="breadcrumb-current">Checkout</span>
        </div>

        {/* Two Column Layout */}
   {clientSecret && (
<Elements stripe={stripePromise} options={{ clientSecret, appearance: { theme: "stripe" } }}>

          <div className="checkout-layout">


            <div className="checkout-left">
   <CheckoutDetailsCard
  checkoutData={checkoutData}
  setCheckoutData={setCheckoutData}
  savedCard={savedCard}
  onChangeCard={() => setSavedCard(null)}
  onValidationChange={setShippingValid}
  validateRef={shippingValidateRef}
/>

            </div>

          <div className="checkout-right">
<OrderSummaryCard
  payNowHandler={payNowHandler}
  userCredit={user?.storeCredit || 0}
  appliedCredit={appliedCredit}
  onApplyCredit={handleApplyCredit}
  clientSecret={clientSecret}
  checkoutData={checkoutData}
  onValidateShipping={() => {
    const valid = shippingValidateRef.current?.();
    if (!valid) {
      alert("Please fill out all required shipping details before placing your order.");
      return false;
    }
    return true;
  }}
/>


<PaymentForm
  clientSecret={clientSecret}
  checkoutData={checkoutData}
  userId={user?.id}
  savedCard={savedCard}
  product={product}
  quantity={quantity}
  selectedCondition={selectedCondition}
  selectedVariant={selectedVariant}
  price={price}
  appliedCredit={appliedCredit}
  onSuccess={(orderId) => {
    navigate(`/invoice/${orderId}`);
  }}
  setPayNowHandler={setPayNowHandler}
/>

</div>

          </div>

        </Elements>
      )}

    </div>

  </div>

);
}